import { createStyles } from "@material-ui/core";
export var styles = function (_theme) {
    return createStyles({
        adornment: {
            maxHeight: "1.6em"
        }
    });
};
